var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.showSiteCodeForm)?_c('SftpStatus'):_vm._e(),(!_vm.showSiteCodeForm)?_c('Providers',{attrs:{"providers":_vm.entity.providers,"show-settings":false,"show-cloud-watch-url":false,"show-latest-cad-data-link":false}}):_vm._e(),(_vm.showSiteCodeForm)?_c('SiteCode'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }